// extracted by mini-css-extract-plugin
export default {"button":"ForgotPasswordButton_button__W2xoC"};